import { gql } from '@apollo/client';

export const GET_AFFILIATE_STREAMS = gql`
  query GetAffiliateStreams($input: AffiliateStreamsInput!) {
    getAffiliateStreams(input: $input) {
      total
      offset
      limit
      entities {
        activeLinksCount
        linksCount
        clicks
        salesCount
        ticketsSoldCount
        revenue
        commissionTotal
        stream {
          id
          name
          slug
          scheduleDateUtc
          price
          affiliateCommissionPercent
          store {
            id
            firstName
            lastName
            slug
            storeDetails {
              id
              storeName
            }
          }
        }
      }
    }
  }
`;

export const GET_STREAM_AFFILIATE_LINKS = gql`
  query GetStreamAffiliateLinks($input: StreamAffiliateLinksInput!) {
    getStreamAffiliateLinks(input: $input) {
      total
      offset
      limit
      entities {
        salesCount
        ticketsSoldCount
        revenue
        commissionEarned
        isParticipant
        link {
          id
          code
          status
          clicks
          commissionPercent
          createdAt
          user {
            id
            email
            firstName
            lastName
            slug
            storeDetails {
              id
              storeName
            }
          }
        }
      }
    }
  }
`;

export const GET_AFFILIATE_COMMISSION_PAYOUTS = gql`
  query GetAffiliateCommissionPayouts(
    $input: AffiliateCommissionPayoutsInput!
  ) {
    getAffiliateCommissionPayouts(input: $input) {
      total
      offset
      limit
      entities {
        salesCount
        commissionTotal
        unpaidCommissionTotal
        user {
          id
          email
          firstName
          lastName
          slug
          storeDetails {
            id
            storeName
          }
        }
        streams {
          salesCount
          commission
          unpaidCommission
          stream {
            id
            name
            scheduleDateUtc
            store {
              id
              firstName
              lastName
              slug
            }
          }
          ticketEvent {
            id
            name
            startsAt
            host {
              id
              firstName
              lastName
              slug
            }
          }
        }
      }
    }
  }
`;
